export const router = [
  {
    path: "information",
    component: (resolve) => require(["./layout/Index.vue"], resolve),
    children: [
      {
        path: "overview",
        component: (resolve) => require(["./overview/Index.vue"], resolve),
      },
      {
        path: "material",
        component: (resolve) => require(["./material/Index.vue"], resolve),
      },
      {
        path: "program",
        component: (resolve) => require(["./program/Index.vue"], resolve),
      },
      // {
      //   path: "program/edit",
      //   component: (resolve) => require(["./program/Program.vue"], resolve),
      // },
      {
        path: "schedule",
        component: (resolve) => require(["./schedule/Index.vue"], resolve),
      },
      {
        path: "schedule/record",
        component: (resolve) =>
          require(["./schedule/PublishRecord.vue"], resolve),
      },
      {
        path: "schedule/detail",
        name: "ScheduleDetail",
        component: (resolve) =>
          require(["./schedule/ScheduleDetail.vue"], resolve),
      },
      {
        path: "schedule/edit",
        component: (resolve) =>
          require(["./schedule/ScheduleEdit.vue"], resolve),
      },
      {
        path: "review/myReview",
        component: (resolve) =>
          require(["./review/my-review/Index.vue"], resolve),
      },
      {
        path: "review/detail",
        component: (resolve) =>
          require(["./review/my-review/Detail.vue"], resolve),
      },
      {
        path: "review/teamReview",
        component: (resolve) =>
          require(["./review/team-review/Index.vue"], resolve),
      },
      {
        path: "review/reviewSet",
        component: (resolve) =>
          require(["./review/ReviewSettings.vue"], resolve),
      },
    ],
  },
];
